// extracted by mini-css-extract-plugin
export default {"root":"classes_root__zg+6-","potential-earnings-row":"classes_potential-earnings-row__AosRP","padding":"classes_padding__e+1UI"};